/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormAuditUpdateResponseDto } from '../../models/form-audit-update-response-dto';

export interface UpdateAuditStatus$Params {
  formId: string;
  formStatus:
    | 'FormApproved'
    | 'FormCancelled'
    | 'FormInProgress'
    | 'FormInReview'
    | 'FormOpen'
    | 'FormRejected'
    | 'FormReturned'
    | 'FormSubmitted'
    | 'FormReadyToSubmit'
    | 'FormReadyToResubmit'
    | 'FormReopened';
}

export function updateAuditStatus(
  http: HttpClient,
  rootUrl: string,
  params: UpdateAuditStatus$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormAuditUpdateResponseDto>> {
  const rb = new RequestBuilder(rootUrl, updateAuditStatus.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.path('formStatus', params.formStatus, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormAuditUpdateResponseDto>;
    })
  );
}

updateAuditStatus.PATH = '/auditing/forms/{formId}/status/{formStatus}';
